import React from "react";

import HexAuthWrapper from "../../components/HexAuthWrapper";
import WithdrawRoute from "../../features/finance/WithdrawRoute";

const FinanceWithdrawPage = () => (
  <div className="finance-withdraw-page full-bleed">
    <HexAuthWrapper>
      <WithdrawRoute />
    </HexAuthWrapper>
  </div>
);

export default FinanceWithdrawPage;
